import { render } from "./AgendaTreinos.vue?vue&type=template&id=34ecd572&scoped=true"
import script from "./AgendaTreinos.vue?vue&type=script&lang=js"
export * from "./AgendaTreinos.vue?vue&type=script&lang=js"

import "./AgendaTreinos.vue?vue&type=style&index=0&id=34ecd572&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ecd572"]])

export default __exports__